module.exports = __webpack_public_path__ + "img/GALLERY-ERTIGA-5.b2f2fddf.jpg";